import { render, staticRenderFns } from "./ToastsAdvance.vue?vue&type=template&id=160b03d4"
import script from "./ToastsAdvance.vue?vue&type=script&lang=js"
export * from "./ToastsAdvance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports